import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bookmark, Trash2, Play, Mail, Bell, BellOff } from "lucide-react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Switch } from "@/components/ui/switch";

export default function SavedSearchesPage() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/saved-searches").then((r) => setItems(r.data.items || []));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    await api.delete(`/saved-searches/${id}`);
    load(); toast.success("Removed");
  };

  const toggleAlert = async (s) => {
    await api.patch(`/saved-searches/${s.id}`, { alert_enabled: !s.alert_enabled });
    load();
  };

  const runNow = async (s) => {
    try {
      const r = await api.post(`/saved-searches/${s.id}/run`);
      if (r.data.email?.id) toast.success(`${r.data.count} matches. Email sent.`);
      else if (r.data.email?.disabled) toast.success(`${r.data.count} matches (email disabled)`);
      else toast.success(`${r.data.count} matches`);
    } catch { toast.error("Run failed"); }
  };

  return (
    <div className="space-y-5" data-testid="saved-searches-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#d4a574] mb-2 font-semibold">Saved Searches</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">Your saved intelligence queries.</h1>
        <p className="text-[13px] text-[#b8ac96] mt-2">Toggle alerts to receive an email when new matches surface.</p>
      </div>
      {items.length === 0 ? (
        <div className="text-center py-16 text-[#7a6d5a] border border-dashed border-[#33291f] rounded-lg">
          <Bookmark size={24} className="mx-auto mb-3 opacity-40" />
          No saved searches yet. Save any list-view search to get alerts.
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((s) => (
            <div key={s.id} data-testid={`saved-${s.id}`} className="border border-[#33291f] rounded-lg bg-[#1c1712] p-4 flex items-center justify-between gap-3 flex-wrap">
              <div className="flex-1 min-w-0">
                <div className="font-display text-lg font-semibold">{s.name}</div>
                <div className="text-[11px] font-mono text-[#7a6d5a] truncate">{JSON.stringify(s.filters)}</div>
              </div>
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2 text-[11px] text-[#b8ac96]">
                  {s.alert_enabled ? <Bell size={13} className="text-[#34d399]" /> : <BellOff size={13} className="text-[#7a6d5a]" />}
                  Email alerts
                  <Switch checked={!!s.alert_enabled} onCheckedChange={() => toggleAlert(s)} data-testid={`alert-toggle-${s.id}`} />
                </div>
                <button onClick={() => runNow(s)} data-testid={`run-${s.id}`} className="p-2 rounded border border-[#33291f] hover:border-[#d4a574] text-[#b8ac96] hover:text-[#d4a574]" title="Run now + email"><Mail size={14} /></button>
                {s.filters?.category && (
                  <Link to={`/app/opportunities/${s.filters.category}`} className="p-2 rounded border border-[#33291f] hover:border-[#d4a574] text-[#b8ac96] hover:text-[#d4a574]"><Play size={14} /></Link>
                )}
                <button onClick={() => del(s.id)} className="p-2 rounded border border-[#33291f] hover:border-[#f87171] text-[#b8ac96] hover:text-[#f87171]"><Trash2 size={14} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
